import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=39cdc436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39cdc436"]])

export default __exports__